<mat-toolbar class="bg-transparent px-0 w-full items-center gap-2 min-w-0 flex"
  (click)="goTo()"
  [ngClass]="{
    'selectable-toolbar hover:cursor-pointer': selectable,
    'justify-end': tableMode,
    'justify-between': !tableMode,
    'premium-page-header-card': !tableMode
  }"
  >
  @if (!tableMode) {
    <div class="flex flex-row items-center flex-1 min-w-0 quotation-text-group">
      @if (authService.isLoggedIn && withBackButton) {
        <button mat-icon-button (click)="location.back()" class="mr-2 btn-back"
          >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      <app-state-indicator [quotation]="quotation"></app-state-indicator>
      <div class="flex flex-col min-w-0 max-w-full pl-2 quotation-title-block">
        <h2 class="m-0 text-lg text-ellipsis overflow-hidden whitespace-nowrap">{{ quotation.erpId }}</h2>
        <span class="quotation-subtitle text-sm text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap">
          {{ quotation.reference }} {{ quotation.description }}<span class="quotation-version"> — {{ 'version'|translate }} #{{ quotation.version }}</span>
        </span>
      </div>
    </div>
  }
  <div class="flex flex-row shrink-0 gap-2" (click)="$event.stopPropagation()">
    <div class="action-shortcuts w-fit flex-row place-content-end gap-2">
      @if (authService.hasRole(RolesEnum.SALES)) {
        <button class="btn-sync" mat-icon-button (click)="sync(quotation)" [class.spinning]="isRotating">
          <mat-icon [class.animate-sync-spin]="isRotating">sync</mat-icon>
        </button>
      }
      @if (authService.hasRole(RolesEnum.SALES)) {
        <app-lock-by-editor [object]="quotation"
        ></app-lock-by-editor>
      }
      <button mat-icon-button (click)="download()" [matTooltip]="'downloadOrderFiles.title'|translate"
        class="btn-download">
        @if (!zipProgress) {
          <mat-icon>download</mat-icon>
        }
        @if (zipProgress) {
          <mat-spinner diameter="22" color="accent" mode="indeterminate"></mat-spinner>
        }
      </button>
      <button mat-icon-button (click)="openQuotationInformationDialog()" [matTooltip]="'common.info.button'|translate"
        class="btn-info">
        <mat-icon>info</mat-icon>
      </button>
    </div>
    @if (authService.isLoggedIn) {
      <button mat-icon-button [matMenuTriggerFor]="quotationNavigationMenu" class="btn-more">
        <mat-icon>more_vert</mat-icon>
      </button>
    }
    <mat-menu #quotationNavigationMenu="matMenu">
      <div class="px-4 w-fit max-w-xs">
        <div class="lg:hidden flex flex-col" (click)="$event.stopPropagation()">
          @if (authService.hasRole(RolesEnum.SALES)) {
            <button mat-menu-item (click)="sync(quotation)">
              <mat-icon [class.animate-sync-spin]="isRotating">sync</mat-icon>
              <span>{{ 'synchronize' | translate }}</span>
            </button>
          }
          @if (authService.hasRole(RolesEnum.SALES)) {
            <app-lock-by-editor [object]="quotation" [isMenuItem]="true" class="w-full"
            ></app-lock-by-editor>
          }
          <button mat-menu-item (click)="download()">
            @if (!zipProgress) {
              <mat-icon>download</mat-icon>
            }
            @if (zipProgress) {
              <mat-spinner diameter="22" color="accent" mode="indeterminate" class="mr-2"></mat-spinner>
            }
            <span>{{ 'downloadOrderFiles.title' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openQuotationInformationDialog()">
            <mat-icon>info</mat-icon>
            <span>{{ 'common.info.button' | translate }}</span>
          </button>
        </div>
        <mat-divider class="my-2 lg:hidden"></mat-divider>
        <button mat-menu-item (click)="sendEmail(quotation)" [disabled]="quotation.state !== QuotationState.SUBMITTED">
          <mat-icon>contact_mail</mat-icon>
          {{ 'sendEmail' | translate }}
        </button>
        <button mat-menu-item (click)="getSignedUrl($event)"
          [disabled]="progress || quotation.state !== QuotationState.SUBMITTED">
          @if (!progress) {
            <mat-icon>link</mat-icon>
          }
          <div class="flex flex-row items-center gap-2">
            @if (progress) {
              <mat-spinner mode="indeterminate" diameter="22" color="accent"></mat-spinner>
            }
            {{ 'quotation.signedUrl' | translate }}
          </div>
        </button>
        <button mat-menu-item (click)="restoreDialog()"
          [disabled]="![QuotationState.SUBMITTED, QuotationState.REFUSED, QuotationState.CANCELED]
            .includes(quotation.state)">
          <mat-icon>restore_page</mat-icon>
          {{ 'restore' | translate }}
        </button>
        @if (quotation.state !== QuotationState.CANCELED && quotation.state !== QuotationState.ACCEPTED) {
          <button mat-menu-item (click)="deleteDialog()">
            <mat-icon>delete</mat-icon>
            {{ 'archive' | translate }}
          </button>
        }
      </div>
    </mat-menu>
  </div>
</mat-toolbar>
